import { createAbortError } from '@uppy/utils/lib/AbortController';
export function throwIfAborted(signal) {
    if (signal?.aborted) {
        throw createAbortError('The operation was aborted', {
            cause: signal.reason,
        });
    }
}
